// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sold {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: var(--paper);
  padding: 16px 20px 24px;
}

.sold-back {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  align-self: flex-start;
  margin: 0 0 16px;
  font-family: var(--font-mono);
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ink-3);
  text-decoration: none;
}

.sold-head {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sold-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
}

.sold-rol {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--ink-3);
}

.sold-badge {
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border: 1px solid var(--cream-deep);
  color: var(--cream-deep);
  padding: 2px 6px;
}

.sold-party {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 500;
  line-height: 1.25;
  letter-spacing: -0.02em;
  color: var(--ink);
}

.sold-kind {
  margin: 0;
  font-size: 0.95rem;
  color: var(--ink-2);
}

.sold-price {
  margin: 8px 0 0;
  font-family: var(--font-mono);
  font-size: 1.15rem;
  color: var(--ink);
}

.sold-due {
  margin: 0;
  font-size: 0.85rem;
  color: var(--ink-3);
}

.sold-fields {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin: 24px 0 0;
  padding: 0;
}

.sold-field dt {
  margin: 0 0 2px;
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--ink-3);
}

.sold-field dd {
  margin: 0;
  font-size: 0.95rem;
  color: var(--ink);
}

/* One line per recipient of the actuation. */
.sold-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 4px;
}

.sold-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: auto;
  padding-top: 24px;
}

.sold-actions .btn {
  width: 100%;
}

.sold-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 24px;
}

.sold--receptor .sold-bank {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
  margin: 10px 0 0;
  padding: 16px 0 0;
  border: 0;
  border-top: 1px solid var(--rule);
}

.sold--receptor .sold-bank legend {
  padding: 0;
  font-size: var(--fs-body);
  font-weight: 500;
}

.sold--receptor .sold-bank p,
.sold--receptor .sold-bank-summary {
  margin: 0;
  font-size: var(--fs-ui);
  overflow-wrap: anywhere;
}

.sold--receptor .sold-bank input,
.sold--receptor .sold-bank select {
  min-width: 0;
  width: 100%;
}

.sold-control {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sold-control span {
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--ink-3);
}

.sold-form-error {
  margin: 0;
  font-size: 0.9rem;
  color: var(--danger);
}

.sold-link {
  color: var(--accent);
  text-decoration: underline;
  text-underline-offset: 2px;
}

/* Plain accent is under 4.5:1 on the light paper, so the light theme uses
   accent-deep. Dark keeps accent: accent-deep is not redefined for navy. */
:root:not([data-theme='dark']) .sold-link {
  color: var(--accent-deep);
}

.sold-form-error__link {
  color: inherit;
  font-weight: 600;
  text-decoration: underline;
}

.sold h1.sol-status__body {
  font-weight: 400;
}

.sold.sold--status.sol-status {
  flex-direction: column;
  gap: 16px;
}

.sold--status .sol-status__body + .sol-status__body {
  margin-top: 16px;
}

/* These selectors only style the authenticated receptor detail/preview.
   Oferta also imports this stylesheet and keeps its existing presentation. */
.sold--receptor .sold-reading {
  display: flow-root;
  min-width: 0;
}

.sold--receptor .sold-notes {
  margin-top: 24px;
  padding: 16px;
  border: 1px solid var(--rule);
  background: var(--surface);
}

.sold--receptor .sold-notes__title {
  margin: 0 0 12px;
  font-family: var(--font-display);
  font-size: var(--fs-md);
  font-weight: 500;
  color: var(--ink);
}

.sold--receptor .sold-notes__body {
  margin: 0;
  max-width: 65ch;
  font-size: var(--fs-body);
  line-height: var(--leading-body);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  color: var(--ink);
}

/* Live region for the confirmation after quoting. It stays mounted, empty,
   so screen readers announce the text when it arrives. */
.sold-notice {
  margin: 8px 0 0;
  font-size: var(--fs-ui);
  color: var(--ink);
}

.sold-notice:empty {
  margin: 0;
}

.sold-answer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid var(--rule);
}

.sold-answer__body {
  margin: 0;
  font-size: var(--fs-body);
  line-height: var(--leading-body);
  color: var(--ink);
}

.sold-answer__paid {
  align-self: flex-start;
  margin: 0;
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border: 1px solid var(--rule);
  color: var(--ink-2);
  padding: 2px 6px;
}

/* Price per recipient (REC-1983). */
.sold-breakdown {
  border: 0;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 12px;
  min-width: 0;
}

.sold-breakdown > legend {
  padding: 0;
  margin-bottom: 4px;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--ink);
}

.sold-breakdown__row {
  display: grid;
  gap: 6px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--rule-soft);
}

.sold-breakdown__who {
  margin: 0;
  font-size: 0.9rem;
  color: var(--ink);
}

.sold-breakdown__fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  /* A label that wraps keeps both inputs on one line. */
  align-items: end;
  gap: 8px;
}

.sold-breakdown__sub {
  margin: 0;
  font-size: 0.85rem;
  color: var(--ink-3);
}

.sold-breakdown__total {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 1.05rem;
  color: var(--ink);
}

/* In the receptor's detail the field labels read like the rest of the form
   (Fecha); /oferta keeps its own label style. */
.sold-form:not(.oferta-form) .sold-breakdown .sold-control label {
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--ink-3);
}

/* Desktop: the request is a page of its own. A compact header, the data as a
   grid of fields, and the answer (or the quote form) as a panel on the right
   with Rechazar and Cotizar pinned to the bottom of the viewport. */
@media (min-width: 1024px) {
  /* Loading, error and not-found states share the page column. */
  .sol-workspace__content .sold:not(.sold--receptor) {
    width: 100%;
    max-width: var(--receptor-page-max, 1200px);
    margin: 0 auto;
    padding: 8px 0 32px;
    background: transparent;
  }

  /* Error and not-found read as a page, left-aligned under the link back;
     loading stays centred. */
  .sold--status:not(.sol-status) {
    align-items: flex-start;
  }

  .sold--status:not(.sol-status) .sol-status__body {
    max-width: 60ch;
    text-align: left;
  }

  .sold--status:not(.sol-status) h1.sol-status__body {
    font-size: var(--fs-h2);
  }

  .sol-workspace__content .sold.sold--receptor {
    display: grid;
    grid-template-columns: minmax(0, 1fr) clamp(300px, 30%, 360px);
    column-gap: 32px;
    align-content: start;
    align-items: start;
    width: 100%;
    max-width: var(--receptor-page-max, 1200px);
    min-height: 0;
    margin: 0 auto;
    padding: 8px 0 32px;
    background: transparent;
  }

  .sold--receptor .sold-back,
  .sold--receptor .sold-head {
    grid-column: 1 / -1;
  }

  .sold--receptor .sold-back {
    margin: 0 0 12px;
  }

  .sold--receptor .sold-head {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: baseline;
    column-gap: 20px;
    row-gap: 4px;
    margin-bottom: 24px;
    padding-bottom: 20px;
    border-bottom: 1px solid var(--rule);
  }

  .sold--receptor .sold-meta,
  .sold--receptor .sold-party,
  .sold--receptor .sold-notice {
    flex-basis: 100%;
  }

  .sold--receptor .sold-party {
    font-size: var(--fs-h2);
    font-weight: 400;
    text-wrap: balance;
    overflow-wrap: anywhere;
  }

  .sold--receptor .sold-kind,
  .sold--receptor .sold-due {
    margin: 0;
    font-size: var(--fs-ui);
    color: var(--ink-2);
  }

  .sold--receptor .sold-price {
    margin: 0;
    font-size: var(--fs-ui);
  }

  .sold--receptor .sold-reading {
    display: flex;
    flex-direction: column;
    gap: 24px;
    grid-column: 1;
    grid-row: 3;
  }

  .sold--receptor .sold-notes {
    margin-top: 0;
    padding: 0 0 0 16px;
    border: 0;
    border-left: 2px solid var(--rule);
    background: transparent;
  }

  .sold--receptor .sold-fields {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: 20px 24px;
    margin-top: 0;
  }

  .sold--receptor .sold-field--wide {
    grid-column: 1 / -1;
  }

  .sold--receptor .sold-field dd {
    font-size: var(--fs-ui);
    line-height: var(--leading-body);
    overflow-wrap: anywhere;
  }

  .sold--receptor .sold-field dt,
  .sold--receptor .sold-control span {
    font-size: var(--fs-eyebrow);
  }

  .sold--receptor .sold-form,
  .sold--receptor .sold-answer {
    --sold-panel-pad: 20px;
    grid-column: 2;
    grid-row: 3;
    min-width: 0;
    margin-top: 0;
    padding: var(--sold-panel-pad);
    border: 1px solid var(--rule);
    background: var(--surface);
  }

  /* The panel grows with its form and the page scrolls; Rechazar and Cotizar
     stick to the bottom of the viewport while any of the panel is in view, so
     a long form (many recipients, an inline bank account) never hides them. */
  .sold--receptor .sold-actions {
    position: sticky;
    bottom: 0;
    grid-template-columns: 1fr 1fr;
    margin: auto calc(-1 * var(--sold-panel-pad))
      calc(-1 * var(--sold-panel-pad));
    padding: 12px var(--sold-panel-pad) var(--sold-panel-pad);
    border-top: 1px solid var(--rule-soft);
    background: var(--surface);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/solicitudes/SolicitudDetail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,6CAA6C;AAC7C;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;2EAC2E;AAC3E;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;6EAC6E;AAC7E;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;yDACyD;AACzD;EACE,eAAe;EACf,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sDAAsD;EACtD,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;gDACgD;AAChD;EACE,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;oEAEoE;AACpE;EACE,+DAA+D;EAC/D;IACE,WAAW;IACX,2CAA2C;IAC3C,cAAc;IACd,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;6BAC2B;EAC3B;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,8DAA8D;IAC9D,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,2CAA2C;IAC3C,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,oCAAoC;EACtC;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;;IAEE,SAAS;IACT,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;IACd,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kCAAkC;IAClC,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,cAAc;IACd,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,gCAAgC;IAChC,uBAAuB;EACzB;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;;8EAE4E;EAC5E;IACE,gBAAgB;IAChB,SAAS;IACT,8BAA8B;IAC9B;sCACkC;IAClC,yDAAyD;IACzD,sCAAsC;IACtC,0BAA0B;EAC5B;AACF","sourcesContent":[".sold {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  background: var(--paper);\n  padding: 16px 20px 24px;\n}\n\n.sold-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  align-self: flex-start;\n  margin: 0 0 16px;\n  font-family: var(--font-mono);\n  font-size: 11px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n  text-decoration: none;\n}\n\n.sold-head {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sold-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n}\n\n.sold-rol {\n  font-family: var(--font-mono);\n  font-size: 12px;\n  color: var(--ink-3);\n}\n\n.sold-badge {\n  font-family: var(--font-mono);\n  font-size: 10px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  border: 1px solid var(--cream-deep);\n  color: var(--cream-deep);\n  padding: 2px 6px;\n}\n\n.sold-party {\n  margin: 0;\n  font-size: 1.35rem;\n  font-weight: 500;\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n  color: var(--ink);\n}\n\n.sold-kind {\n  margin: 0;\n  font-size: 0.95rem;\n  color: var(--ink-2);\n}\n\n.sold-price {\n  margin: 8px 0 0;\n  font-family: var(--font-mono);\n  font-size: 1.15rem;\n  color: var(--ink);\n}\n\n.sold-due {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--ink-3);\n}\n\n.sold-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin: 24px 0 0;\n  padding: 0;\n}\n\n.sold-field dt {\n  margin: 0 0 2px;\n  font-family: var(--font-mono);\n  font-size: 10px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n}\n\n.sold-field dd {\n  margin: 0;\n  font-size: 0.95rem;\n  color: var(--ink);\n}\n\n/* One line per recipient of the actuation. */\n.sold-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: 4px;\n}\n\n.sold-actions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-top: auto;\n  padding-top: 24px;\n}\n\n.sold-actions .btn {\n  width: 100%;\n}\n\n.sold-form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-top: 24px;\n}\n\n.sold--receptor .sold-bank {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  min-width: 0;\n  margin: 10px 0 0;\n  padding: 16px 0 0;\n  border: 0;\n  border-top: 1px solid var(--rule);\n}\n\n.sold--receptor .sold-bank legend {\n  padding: 0;\n  font-size: var(--fs-body);\n  font-weight: 500;\n}\n\n.sold--receptor .sold-bank p,\n.sold--receptor .sold-bank-summary {\n  margin: 0;\n  font-size: var(--fs-ui);\n  overflow-wrap: anywhere;\n}\n\n.sold--receptor .sold-bank input,\n.sold--receptor .sold-bank select {\n  min-width: 0;\n  width: 100%;\n}\n\n.sold-control {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.sold-control span {\n  font-family: var(--font-mono);\n  font-size: 10px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n}\n\n.sold-form-error {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--danger);\n}\n\n.sold-link {\n  color: var(--accent);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n/* Plain accent is under 4.5:1 on the light paper, so the light theme uses\n   accent-deep. Dark keeps accent: accent-deep is not redefined for navy. */\n:root:not([data-theme='dark']) .sold-link {\n  color: var(--accent-deep);\n}\n\n.sold-form-error__link {\n  color: inherit;\n  font-weight: 600;\n  text-decoration: underline;\n}\n\n.sold h1.sol-status__body {\n  font-weight: 400;\n}\n\n.sold.sold--status.sol-status {\n  flex-direction: column;\n  gap: 16px;\n}\n\n.sold--status .sol-status__body + .sol-status__body {\n  margin-top: 16px;\n}\n\n/* These selectors only style the authenticated receptor detail/preview.\n   Oferta also imports this stylesheet and keeps its existing presentation. */\n.sold--receptor .sold-reading {\n  display: flow-root;\n  min-width: 0;\n}\n\n.sold--receptor .sold-notes {\n  margin-top: 24px;\n  padding: 16px;\n  border: 1px solid var(--rule);\n  background: var(--surface);\n}\n\n.sold--receptor .sold-notes__title {\n  margin: 0 0 12px;\n  font-family: var(--font-display);\n  font-size: var(--fs-md);\n  font-weight: 500;\n  color: var(--ink);\n}\n\n.sold--receptor .sold-notes__body {\n  margin: 0;\n  max-width: 65ch;\n  font-size: var(--fs-body);\n  line-height: var(--leading-body);\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  color: var(--ink);\n}\n\n/* Live region for the confirmation after quoting. It stays mounted, empty,\n   so screen readers announce the text when it arrives. */\n.sold-notice {\n  margin: 8px 0 0;\n  font-size: var(--fs-ui);\n  color: var(--ink);\n}\n\n.sold-notice:empty {\n  margin: 0;\n}\n\n.sold-answer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid var(--rule);\n}\n\n.sold-answer__body {\n  margin: 0;\n  font-size: var(--fs-body);\n  line-height: var(--leading-body);\n  color: var(--ink);\n}\n\n.sold-answer__paid {\n  align-self: flex-start;\n  margin: 0;\n  font-family: var(--font-mono);\n  font-size: 10px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  border: 1px solid var(--rule);\n  color: var(--ink-2);\n  padding: 2px 6px;\n}\n\n/* Price per recipient (REC-1983). */\n.sold-breakdown {\n  border: 0;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 12px;\n  min-width: 0;\n}\n\n.sold-breakdown > legend {\n  padding: 0;\n  margin-bottom: 4px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--ink);\n}\n\n.sold-breakdown__row {\n  display: grid;\n  gap: 6px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--rule-soft);\n}\n\n.sold-breakdown__who {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--ink);\n}\n\n.sold-breakdown__fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  /* A label that wraps keeps both inputs on one line. */\n  align-items: end;\n  gap: 8px;\n}\n\n.sold-breakdown__sub {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--ink-3);\n}\n\n.sold-breakdown__total {\n  margin: 0;\n  font-family: var(--font-mono);\n  font-size: 1.05rem;\n  color: var(--ink);\n}\n\n/* In the receptor's detail the field labels read like the rest of the form\n   (Fecha); /oferta keeps its own label style. */\n.sold-form:not(.oferta-form) .sold-breakdown .sold-control label {\n  font-family: var(--font-mono);\n  font-size: 10px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n}\n\n/* Desktop: the request is a page of its own. A compact header, the data as a\n   grid of fields, and the answer (or the quote form) as a panel on the right\n   with Rechazar and Cotizar pinned to the bottom of the viewport. */\n@media (min-width: 1024px) {\n  /* Loading, error and not-found states share the page column. */\n  .sol-workspace__content .sold:not(.sold--receptor) {\n    width: 100%;\n    max-width: var(--receptor-page-max, 1200px);\n    margin: 0 auto;\n    padding: 8px 0 32px;\n    background: transparent;\n  }\n\n  /* Error and not-found read as a page, left-aligned under the link back;\n     loading stays centred. */\n  .sold--status:not(.sol-status) {\n    align-items: flex-start;\n  }\n\n  .sold--status:not(.sol-status) .sol-status__body {\n    max-width: 60ch;\n    text-align: left;\n  }\n\n  .sold--status:not(.sol-status) h1.sol-status__body {\n    font-size: var(--fs-h2);\n  }\n\n  .sol-workspace__content .sold.sold--receptor {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) clamp(300px, 30%, 360px);\n    column-gap: 32px;\n    align-content: start;\n    align-items: start;\n    width: 100%;\n    max-width: var(--receptor-page-max, 1200px);\n    min-height: 0;\n    margin: 0 auto;\n    padding: 8px 0 32px;\n    background: transparent;\n  }\n\n  .sold--receptor .sold-back,\n  .sold--receptor .sold-head {\n    grid-column: 1 / -1;\n  }\n\n  .sold--receptor .sold-back {\n    margin: 0 0 12px;\n  }\n\n  .sold--receptor .sold-head {\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: baseline;\n    column-gap: 20px;\n    row-gap: 4px;\n    margin-bottom: 24px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid var(--rule);\n  }\n\n  .sold--receptor .sold-meta,\n  .sold--receptor .sold-party,\n  .sold--receptor .sold-notice {\n    flex-basis: 100%;\n  }\n\n  .sold--receptor .sold-party {\n    font-size: var(--fs-h2);\n    font-weight: 400;\n    text-wrap: balance;\n    overflow-wrap: anywhere;\n  }\n\n  .sold--receptor .sold-kind,\n  .sold--receptor .sold-due {\n    margin: 0;\n    font-size: var(--fs-ui);\n    color: var(--ink-2);\n  }\n\n  .sold--receptor .sold-price {\n    margin: 0;\n    font-size: var(--fs-ui);\n  }\n\n  .sold--receptor .sold-reading {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    grid-column: 1;\n    grid-row: 3;\n  }\n\n  .sold--receptor .sold-notes {\n    margin-top: 0;\n    padding: 0 0 0 16px;\n    border: 0;\n    border-left: 2px solid var(--rule);\n    background: transparent;\n  }\n\n  .sold--receptor .sold-fields {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));\n    gap: 20px 24px;\n    margin-top: 0;\n  }\n\n  .sold--receptor .sold-field--wide {\n    grid-column: 1 / -1;\n  }\n\n  .sold--receptor .sold-field dd {\n    font-size: var(--fs-ui);\n    line-height: var(--leading-body);\n    overflow-wrap: anywhere;\n  }\n\n  .sold--receptor .sold-field dt,\n  .sold--receptor .sold-control span {\n    font-size: var(--fs-eyebrow);\n  }\n\n  .sold--receptor .sold-form,\n  .sold--receptor .sold-answer {\n    --sold-panel-pad: 20px;\n    grid-column: 2;\n    grid-row: 3;\n    min-width: 0;\n    margin-top: 0;\n    padding: var(--sold-panel-pad);\n    border: 1px solid var(--rule);\n    background: var(--surface);\n  }\n\n  /* The panel grows with its form and the page scrolls; Rechazar and Cotizar\n     stick to the bottom of the viewport while any of the panel is in view, so\n     a long form (many recipients, an inline bank account) never hides them. */\n  .sold--receptor .sold-actions {\n    position: sticky;\n    bottom: 0;\n    grid-template-columns: 1fr 1fr;\n    margin: auto calc(-1 * var(--sold-panel-pad))\n      calc(-1 * var(--sold-panel-pad));\n    padding: 12px var(--sold-panel-pad) var(--sold-panel-pad);\n    border-top: 1px solid var(--rule-soft);\n    background: var(--surface);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
